import type { ReactNode } from 'react';
import { PageHeader, type BreadcrumbItem } from '@/components/ui';
import { useDocumentTitle } from '@/lib/hooks/useDocumentTitle';
import styles from '@/app/app.module.css';
import { RouterBreadcrumbs } from './RouterLink';

export interface PageProps {
  title: string;
  description?: ReactNode;
  breadcrumbs?: BreadcrumbItem[];
  actions?: ReactNode;
  meta?: ReactNode;
  tabs?: ReactNode;
  children: ReactNode;
}

/** Standard page frame: document title, header (breadcrumbs, title, actions) and content column. */
export function Page({
  title,
  description,
  breadcrumbs,
  actions,
  meta,
  tabs,
  children,
}: PageProps) {
  useDocumentTitle(title);
  return (
    <div className={styles.page}>
      <PageHeader
        title={title}
        description={description}
        breadcrumbs={breadcrumbs ? <RouterBreadcrumbs items={breadcrumbs} /> : undefined}
        actions={actions}
        meta={meta}
        tabs={tabs}
      />
      {children}
    </div>
  );
}
